import { useMemo } from 'react'
import { SavedOrder } from './state/orderState'
import useCartState from './useCartState'
import usePayments, { PaymentDetails } from './usePayments'
import CartUtils from '@order/CartUtils'

export type CartItem = SavedOrder & {
  payment?: PaymentDetails
}

const useCartItems = () => {
  const cart = useCartState((s) => s.orders)
  const payments = usePayments((s) => s.payments)

  const paymentMap = useMemo(() => {
    const map = new Map<string, PaymentDetails>()

    Object.values(payments).forEach((payment) => {
      payment.orderIds.forEach((orderId) => {
        map.set(orderId, payment)
      })
    })
    return map
  }, [payments])

  const items = useMemo(() => {
    return cart.map((order) => {
      const payment = paymentMap.get(order.id)
      return {
        ...order,
        payment,
      }
    })
  }, [cart, paymentMap])

  const dictionary = useMemo(() => {
    return CartUtils.toDictionary(items)
  }, [items])

  return useMemo(
    () => ({
      list: items,
      dictionary,
      payments: paymentMap,
    }),
    [items, paymentMap, dictionary]
  )
}

export default useCartItems
